const dev = {
    //API_ENDPOINT_URL: "http://192.168.0.107:8811/api",
    API_ENDPOINT_URL: "https://api.formclue.io/v1.0"
};

const prod = {
    API_ENDPOINT_URL: "https://api.formclue.io/v1.0"
};

const test = {
    API_ENDPOINT_URL: '/api'
};

const getEnv = () => {
    switch (process.env.NODE_ENV) {
        case 'development':
            return dev
        case 'production':
            return prod
        case 'test':
            return test
        default:
            break;
    }
}

export const env = getEnv()
